/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Grid,
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import './ApplyLeaveModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CustomAutoComplete from '../../../../common/components/CustomAutoComplete/CustomAutoComplete';
import moment from 'moment';
import { fonts, themes } from '../../../themes/themes';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import toast from 'react-hot-toast';
import CompDirection from '../../../themes/CompDirection';
import _ from 'lodash';
import { DatePickerInput } from '../../../../components';
import { defaultDateFormatting } from '../../../helper';
import { useList } from '../../../../api';
import Loader from '../../../Lottifiers/Loader/Loader';

// const addOneDay = (date: string | Date, convertToUtc: boolean) => {
//   return moment(
//     convertUtcToDate(date, baseDateTimeFormatting, null, convertToUtc),
//   )
//     .add(24, 'hours')
//     .format(baseDateTimeFormatting);
// };

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allLeaveTypes: any;
  callBackGetData: (data: any) => void;
  leaveEligibility: any;
  trans?: any;
  i18n?: any;
  leaveEnhanceEligibilities?: any;
  disable?: any;
}

const AboutMeModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allLeaveTypes,
  trans,
  i18n,
  leaveEnhanceEligibilities,
  disable
}: ModalProps) => {
  const encashtype = [
    { name: trans('Leave Advance'), value: 'Leave Advance' },
    { name: trans('Leave Encashment'), value: 'Leave Encashment' },
  ];
  const [reason, setReason] = useState('');
  const [leaveValue, setLeaveValue] = useState('1');
  const [leaveencashtype, setLeaveencashtype] = useState();

  const [leaveType, setLeaveType] = useState<any>('');
  const [leaveTypeName, setLeaveTypeName] = useState('');
  const [selectedLeaveType, setSelectedLeaveType] = useState({
    leave_advance: false,
    leave_encash: false,
  });

  const [leaveTypeId, setLeaveTypeId] = useState(0);
  const [leaveDocumentFile, setLeaveDocumentFile] = useState();
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');

  const [leaveDocumentFilePath, setLeaveDocumentFilePath] = useState('');
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [firstSecondHalf, setFirstSecondHalf] = useState<any>();
  const [, setIsSubmit] = useState<boolean>(false);
  const [isError] = useState<boolean>(false);
  const [newattachement, setNewAttachement] = useState(false);

  const {
    data: numberOfDays,
    isLoading,
    isRefetching,
    isFetching,
  } = useList(
    'leaves/days-to-be-applied',
    {
      leaveTypeId,
      startDate,
      endDate,
    },
    {
      enabled:
        leaveType && startDate && endDate && leaveValue === `${1}`
          ? true
          : false,
    },
  );

  const handleChange = (event: any) => {
    setLeaveValue(event.target.value);
  };
  const handleChangeencash = (event: any) => {
    setLeaveencashtype(event.target.value);
  };

  const handleChangeFirstSecondHalf = (event: any) => {
    setFirstSecondHalf(event.target.value);
  };

  const handleEndDate = (value: any) => {
    setEndDate(value);
  };

  const handleStartDate = (value: any) => {
    setStartDate(value);
  };

  const leaveDocumentUpload = (e: any) => {
    const file: any = e.target.files[0];
    setNewAttachement(true);
    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;
      setLeaveDocumentFile(image_as_files);
      setLeaveDocumentFilePath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setLeaveDocumentFile(file);
    }
  };
  const handleSetLeaveType = (leaveName: any) => {
    const getLeave = _.filter(allLeaveTypes, function (leave: any) {
      return leave.name === leaveName;
    });
    if (getLeave.length) {
      const leave_type = getLeave[0];
      setLeaveType(leave_type?.type);
      setLeaveTypeId(leave_type.id);
      setLeaveTypeName(leaveName);
      setSelectedLeaveType(leave_type);
    } else {
      setSelectedLeaveType({ leave_advance: false, leave_encash: false });
    }
  };

  const handleSubmit = () => {
    setIsSubmit(true);

    const start_date = moment(startDate).format('YYYY-MM-DD');
    const end_date = moment(endDate).format('YYYY-MM-DD');

    if ((!isError && start_date < end_date) || start_date == end_date) {
      if (leaveValue === '0.5' && !firstSecondHalf) {
        toast.error('Please select First half or Second half');
        return;
      }

      if (moment(end_date).isBefore(moment(start_date))) {
        toast.error(trans('End date should be greater than start date'));
        return;
      }

      callBackGetData({
        leaveTypeId: leaveTypeId,
        startDate,
        firstSecondHalf: firstSecondHalf,
        endDate: leaveValue === '0.5' ? startDate : endDate,
        dayFreq: leaveValue,
        reason: reason,
        file: leaveDocumentFile,
        encashtype: leaveencashtype,
        newattachement: newattachement,
      });
    } else if (isError) {
      toast.error(
        trans(
          'Cannot Apply Leave! Leave entitlements for this leave type is exceeded',
        ),
      );
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="90vh"
      modalWidth="470px"
      height="90vh"
    >
      <ModalHeader
        modal={{ modal_title: trans('Apply Leave') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '20px',
            height: '75vh',
            overflowY: 'auto',
            padding: '0 10px',
          }}
        >
          <Grid item xs={12}>
            <RadioGroup
              name="radio-buttons-group"
              value={leaveValue}
              onChange={handleChange}
            >
              <Grid container>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginLeft: '-1.2em',
                  }}
                >
                  <Box
                    className="border-checkBox_leave"
                    style={
                      i18n.language == 'ar'
                        ? {
                            paddingRight: '1.25em',
                          }
                        : { marginRight: '' }
                    }
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio
                          sx={{
                            '&.Mui-checked': {
                              color: themes.primaryMain,
                            },
                          }}
                        />
                      }
                      label={trans('Full Day')}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginLeft: '1.2em',
                    paddingLeft: '1.2em',
                  }}
                >
                  <Box
                    className="border-checkBox_leave"
                    style={
                      i18n.language == 'ar'
                        ? {
                            marginRight: '1.75em',
                            paddingRight: '1.25em',
                          }
                        : { marginRight: '' }
                    }
                  >
                    <FormControlLabel
                      value="0.5"
                      control={
                        <Radio
                          sx={{
                            '&.Mui-checked': {
                              color: themes.primaryMain,
                            },
                          }}
                          disabled={leaveType == 'Halfpaid'}
                        />
                      }
                      label={trans('Half Day')}
                    />
                  </Box>
                </Grid>
              </Grid>
            </RadioGroup>
          </Grid>

          {/* First Half and Second Half */}

          {leaveValue === '0.5' && (
            <Grid item xs={12}>
              <RadioGroup
                name="radio-buttons-group"
                value={firstSecondHalf}
                onChange={handleChangeFirstSecondHalf}
              >
                <Grid container>
                  <Grid
                    item
                    xs={6}
                    style={{
                      marginLeft: '-1.2em',
                    }}
                  >
                    <Box
                      className="border-checkBox_leave"
                      style={
                        i18n.language == 'ar'
                          ? {
                              paddingRight: '1.25em',
                            }
                          : { marginRight: '' }
                      }
                    >
                      <FormControlLabel
                        value="1"
                        control={
                          <Radio
                            sx={{
                              '&.Mui-checked': {
                                color: themes.primaryMain,
                              },
                            }}
                          />
                        }
                        label={trans('First Half')}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      marginLeft: '1.2em',
                      paddingLeft: '1.2em',
                    }}
                  >
                    <Box
                      className="border-checkBox_leave"
                      style={
                        i18n.language == 'ar'
                          ? {
                              marginRight: '1.75em',
                              paddingRight: '1.25em',
                            }
                          : { marginRight: '' }
                      }
                    >
                      {' '}
                      <FormControlLabel
                        value="2"
                        control={
                          <Radio
                            sx={{
                              '&.Mui-checked': {
                                color: themes.primaryMain,
                              },
                            }}
                          />
                        }
                        label={trans('Second Half')}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </RadioGroup>
            </Grid>
          )}

          <Grid item xs={12}>
            <CustomAutoComplete
              label={trans('Leave Type')}
              options={_.map(allLeaveTypes, (leave: any) => {
                return leave.name;
              })}
              value={leaveTypeName}
              onChange={(event: any, newValue: any) => {
                handleSetLeaveType(newValue);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <DatePickerInput
              width="100%"
              label={trans('Start Date')}
              value={startDate}
              supportUTC={false}
              onChange={(newValue: any) => {
                const formattedDate = moment(newValue).format(
                  defaultDateFormatting,
                );
                handleStartDate(formattedDate);
              }}
            />
          </Grid>
          {leaveValue !== (0.5).toString() ? (
            <Grid item xs={12}>
              <DatePickerInput
                width="100%"
                label={trans('End Date')}
                value={endDate}
                supportUTC={false}
                minDate={startDate}
                onChange={(newValue: any) => {
                  const formattedDate = moment(newValue).format(
                    defaultDateFormatting,
                  );
                  handleEndDate(formattedDate);
                }}
              />
            </Grid>
          ) : null}

          {leaveValue !== (0.5).toString() && numberOfDays ? (
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  fontStyle: 'italic',
                }}
              >
                {trans('Total Days')}: {numberOfDays?.data?.days}
              </Typography>
            </Grid>
          ) : isLoading || isRefetching || isFetching ? (
            <Loader height={40} width={60} />
          ) : null}

          <Grid item xs={12}>
            <CustomTextField
              type="string"
              label={trans('Reason')}
              placeholder={trans('Write Reason')}
              value={reason}
              onChange={(e: any) => setReason(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <DropAndSelect
              upload={leaveDocumentUpload}
              src={leaveDocumentFilePath}
              isPDF={isPDF}
              pdfName={pdfName}
              onDelete={() => {
                setPDFName('');
                setIsPDF(false);
                setLeaveDocumentFilePath('');
                setNewAttachement(false);
              }}
            />
          </Grid>
          {leaveEnhanceEligibilities?.findIndex(
            (e: any) =>
              e.name == 'Leave Advance' || e.name == 'Leave Encashment',
          ) >= 0 &&
          selectedLeaveType &&
          (selectedLeaveType?.leave_advance ||
            selectedLeaveType?.leave_encash) ? (
            <Grid item xs={6} style={{ marginTop: '0.5em' }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {trans('Encashment Type')}
                </InputLabel>
                <Select
                  label={trans('Encashment Type')}
                  value={leaveencashtype}
                  onChange={handleChangeencash}
                >
                  {_.map(encashtype, (leave: any) => {
                    if (
                      leaveEnhanceEligibilities?.findIndex(
                        (e: any) => e.name == leave.value,
                      ) >= 0 &&
                      ((leave.value == 'Leave Advance' &&
                        selectedLeaveType?.leave_advance) ||
                        (leave.value == 'Leave Encashment' &&
                          selectedLeaveType?.leave_encash))
                    )
                      return (
                        <MenuItem value={leave.value}>
                          {trans(leave.name)}
                        </MenuItem>
                      );
                  })}
                </Select>
              </FormControl>
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </CompDirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        isSubmitting={disable}
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default AboutMeModalPresenter;
